export default __webpack_public_path__ + "static/media/menu-notices-white.aad7751c.svg";